export default "__VITE_ASSET__GF7j2xQ9__"